module.exports = __webpack_public_path__ + "img/pi-1.2464d538.jpeg";